import BaseResource from './index'

export default class TeamRequestResource extends BaseResource {
    static endpoint = '/teams/requests'

    async accept() {
        const result = await this.wrap('/accept').post()
        return new TeamRequestResource(result.data)
    }

    async decline() {
        const result = await this.wrap('/decline').post()
        return new TeamRequestResource(result.data)
    }
}
